import ProjectTeamModule from './project-team.module'

export default ProjectTeamModule
